import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Currently working for XRSpace as a dept lead, and also a speaker and volunteer in the DDDTW community. Years of software development experience. Like to study kinds of opensource tools and bring them to work to increase efficiency. Believe that smart laziness is the most important characteristic of engineers.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      